import { PINTEREST_TAG_ID } from '../constants';

const isPinterestLoaded = () => typeof pintrk !== 'undefined';

export const PinterestTag = {
  init: (email?: string) => {
    if (!isPinterestLoaded() || !PINTEREST_TAG_ID) return;
    pintrk('load', PINTEREST_TAG_ID, email ? { em: email } : undefined);
    pintrk('page');
  },

  pageVisit: (data?: Record<string, unknown>) => {
    if (!isPinterestLoaded()) return;
    pintrk('track', 'pagevisit', data);
  },

  addToCart: (data?: { product_id?: string; product_name?: string; value?: number; quantity?: number }) => {
    if (!isPinterestLoaded()) return;
    pintrk('track', 'addtocart', data);
  },

  checkout: (data?: { value?: number; order_quantity?: number; currency?: string }) => {
    if (!isPinterestLoaded()) return;
    pintrk('track', 'checkout', data);
  },

  lead: (data?: { lead_type?: string }) => {
    if (!isPinterestLoaded()) return;
    pintrk('track', 'lead', data);
  },

  custom: (eventName: string, data?: Record<string, unknown>) => {
    if (!isPinterestLoaded()) return;
    pintrk('track', 'custom', { custom_event_name: eventName, ...data });
  },
};
